"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function get() {
    return _constants.version;
  }
});
Object.defineProperty(exports, "versions", {
  enumerable: true,
  get: function get() {
    return _constants.versions;
  }
});
Object.defineProperty(exports, "connectionCodeSchemas", {
  enumerable: true,
  get: function get() {
    return _constants.connectionCodeSchemas;
  }
});
Object.defineProperty(exports, "connectionCodeSeparator", {
  enumerable: true,
  get: function get() {
    return _constants.connectionCodeSeparator;
  }
});
Object.defineProperty(exports, "stages", {
  enumerable: true,
  get: function get() {
    return _constants.stages;
  }
});
Object.defineProperty(exports, "rtc", {
  enumerable: true,
  get: function get() {
    return _constants.rtc;
  }
});
Object.defineProperty(exports, "iceConnectionState", {
  enumerable: true,
  get: function get() {
    return _constants.iceConnectionState;
  }
});
Object.defineProperty(exports, "RTCSignalingState", {
  enumerable: true,
  get: function get() {
    return _constants.RTCSignalingState;
  }
});
Object.defineProperty(exports, "RTCIceGatheringState", {
  enumerable: true,
  get: function get() {
    return _constants.RTCIceGatheringState;
  }
});
Object.defineProperty(exports, "lifeCycle", {
  enumerable: true,
  get: function get() {
    return _constants.lifeCycle;
  }
});
Object.defineProperty(exports, "communicationTypes", {
  enumerable: true,
  get: function get() {
    return _constants.communicationTypes;
  }
});
Object.defineProperty(exports, "loggerLevels", {
  enumerable: true,
  get: function get() {
    return _constants.loggerLevels;
  }
});
exports.signal = exports.signals = exports.signalServer = void 0;

var _constants = require("./constants");

var _signals = require("./signals");

var _config = require("../config");

var signalUrl = {
  V1: _config.V1endpoint,
  V2: _config.V2endpoint
};
var signals = {
  V1: _signals.signalV1,
  V2: _signals.signalV2
};
exports.signals = signals;

var versionIdentify = function versionIdentify(ver) {
  var parts = ver.toString().split('.');

  if (parts.length > 0) {
    ver = parts[0];
  }

  switch (ver) {
    case 1:
    case '1':
    case 'V1':
      return 'V1';

    case 2:
    case '2':
    case 'V2':
      return 'V2';

    default:
      return 'V2';
  }
};

var signalServer = function signalServer(ver) {
  return signalUrl[versionIdentify(ver)];
};

exports.signalServer = signalServer;

var signal = function signal(ver) {
  return signals[versionIdentify(ver)];
};

exports.signal = signal;